<template>
  <!-- <div class="frmware-detail-bd"> -->
  <custom-draw width="1400px" :title="model.title" class="way" :visible="visible" v-on="$listeners">
    <div class="draw-body frmware-detail-bd">
      <div class="info-box">
        <div class="title">
          {{ $t('dms_resource_detail_dialog.gu_jian_xin_xi') }}
        </div>
        <ul class="information">
          <li class="line">
            {{ $t('dms_resource_detail_dialog.gu_jian_ming_cheng') }}
            <span class="right">{{ info.resourceCode || '-' }}</span>
          </li>
          <li class="line">
            {{ $t('dms_resource_detail_dialog.gu_jian_ban_ben_hao') }}
            <span class="right">{{ info.resourceVersion || '-' }}</span>
          </li>
          <li class="line">
            {{ $t('dms_resource_detail_dialog.gu_jian_lei_xing') }}
            <span class="right">{{ getDicValue('iot_tsl_resource_type', info.resourceType) || '-' }}</span>
          </li>
          <li class="line">
            {{ $t('dms_resource_detail_dialog.zi_yuan_da_xiaoKB') }}
            <span class="right">{{ getSourceSize(info.attachSize) || '-' }}</span>
          </li>
          <li class="line">
            {{ $t('dms_resource_detail_dialog.gu_jian_zhuang_tai') }}
            <span class="right">{{getDicValue('dms_service_modem_state', info.state)   || '-' }}</span>
          </li>
        </ul>
        <ul class="information-loog">
          <li class="line">
            <p class="label">
              {{ $t('dms_resource_detail_dialog.xxjrdgjbbh') }}
            </p>
            <p class="inner">{{ info.supportPreVersion || '-' }}</p>
          </li>
          <li class="line">
            <p class="label">
              {{ $t('dms_resource_detail_dialog.gu_jian_miao_shu') }}
            </p>
            <p class="inner">{{ info.resourceDesc || '-' }}</p>
          </li>
        </ul>
      </div>
      <div class="table-box">
        <p class="title">
          {{ $t('dms_resource_detail_dialog.yglwmx') }}
        </p>
        <div class="table-bd">
          <custom-table height="100%" :data="info.protocolList" :column="tableColumn" :index="true" @filter="filterChange" @sort="sortChange"></custom-table>
        </div>
        <div class="file-box">
          <p>
            {{ $t('dms_resource_detail_dialog.gu_jian_bao') }}
          </p>
          <!-- 固件文件 -->
          <div class="form-box">
            <t-upload type="file" :bizId="resourceId" bizType="iot.firmware" v-model="fileList" :disabled="true" :download="!!funcView.resource_download" tip></t-upload>
          </div>
        </div>
      </div>
    </div>
  </custom-draw>
  <!-- </div> -->
</template>

<script>
import apis from '@/utils/apis';
import tUpload from '@/components/upload.vue';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  components: { tUpload },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      tableCode: 'protocolRelated',
      // formSearch: {
      //   search: '',
      //   templetId: '',
      //   pageSize: 50,
      //   pageNum: 1,
      //   isAssociated: 1
      // },
      fileList: [],
      resourceId: '',
      taskId: '',
      info: {
        firmwareInfo: {
          firmwareType: '',
        },
      },
    };
  },
  mounted() {
    this.initDialog();
    this.getFuncView();
  },
  methods: {
    getSourceSize(val) {
      if (val) {
        return (val / 1024).toFixed(2);
      }
      return val;
    },
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      // 赋值产品id
      this.resourceId = this.model.data.resourceId;

      // 查字典
      // this.getDictionary('dms_protocol_templetInfo_type');

      this.getTaskStateInfo();

      this.getTableColumn();
    },

    progressFormat: function (percentage) {
      return percentage === '';
    },
    // table字典
    getTaskStateInfo: function () {
      this.$getJSON(`${apis.resourceInfo}/${this.model.data.resourceId}`).then((res) => {
        this.info = res.data;
      });
    },
    // 切换页 和搜索
    onCurrentPage: function (page) {
      this.formSearch.pageNum = page;
      // 更新参数列表
      this.getProtocolParamData();
    },
    onSizeChange: function (size) {
      this.formSearch.pageSize = size;
      this.getProtoList();
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close');
      }, 250);
    },
    saveProtocolConfig: function () {
      this.closeDialog();
    },
  },
};
</script>

<style lang="scss">
// .frmware-detail-bd {

.frmware-detail-bd {
  display: flex;
  height: 100%;
  position: relative;
  // .el-drawer__body {
  //   height: calc(100% - 55px);
  //   padding: 0 !important;
  //   display: flex;
  .info-box {
    flex: 0 0 300px;
    width: 300px;
    background-color: rgba(248, 249, 251, 1);
    padding: 0 24px;
    // height: 100%;
    .title {
      height: 60px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(73, 80, 87, 1);
      line-height: 60px;
    }
    .information {
      .line {
        height: 40px;
        line-height: 40px;
        background: rgba(255, 255, 255, 0);
        border-bottom: 1px solid rgba(238, 242, 247, 1);
        font-size: 12px;
        color: rgba(108, 117, 125, 1);
        span {
          float: right;
          font-size: 12px;
          color: rgba(108, 117, 125, 1);
        }
      }
    }
    .information-loog {
      .line {
        // display: flex;
        padding-bottom: 11px;
        border-bottom: 1px solid rgba(238, 242, 247, 1);
        .label {
          height: 34px;
          line-height: 34px;
          font-size: 12px;
          color: rgba(108, 117, 125, 1);
        }
        .inner {
          font-size: 12px;
          color: rgba(152, 166, 173, 1);
          line-height: 17px;
          width: 100%;
          word-wrap: break-word;
          word-break: break-all;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }
  }
  .table-box {
    flex: 1;
    padding: 0 24px;
    display: flex;
    flex-direction: column;
    .title {
      height: 60px;
      line-height: 60px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(73, 80, 87, 1);
    }
    .table-bd {
      flex: 7;
      height: auto;
    }
    .file-box {
      flex: 3;
      p {
        height: 60px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(73, 80, 87, 1);
        line-height: 60px;
      }
    }
  }

  // }
}
// }
</style>
